// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import PromiseUtil from "../../../../engines/libs/PromiseUtil";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EscortGoodsResultLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelEscortResult: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelEscortKillCivilian: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelEscortLetOffBandit: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelEscortAllPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelKillCivilian: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelLetOffBandit: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelKillBandit: cc.Label = null;

    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
		this.initLayer();
    }

	initLayer() {
		let killBanditCount: number = this._carryData.killBanditCount;
		let letOffBanditCount: number = this._carryData.letOffBanditCount;
		let killCivilianCount: number = this._carryData.killCivilianCount;
		this.labelKillBandit.string = killBanditCount + '人';
		this.labelLetOffBandit.string = letOffBanditCount + '人';
		this.labelKillCivilian.string = killCivilianCount + '人';

		const addColor = cc.color(0x7A, 0xB2, 0x26);
		const subColor = cc.color(0xCE, 0x5C, 0x3F);
		let csvInfo = this._carryData.csvInfo;
		let award = Number(csvInfo.award);
		let let_off_decuct = Number(csvInfo.let_off_decuct);
		let deduct_award = Number(csvInfo.deduct_award);
		let letOff = letOffBanditCount * let_off_decuct;
		let killCivi = killCivilianCount * deduct_award;
		let ret = award - letOff - killCivi;

		this.labelEscortAllPrice.string = data_control.getNumberFormat(award);
		this.labelEscortLetOffBandit.string = "-" + data_control.getNumberFormat(letOff);
		this.labelEscortKillCivilian.string = "-" + data_control.getNumberFormat(killCivi);
		this.labelEscortResult.string = (ret > 0 ? '+' : '') + data_control.getNumberFormat(ret);
		this.labelEscortResult.node.color = ret > 0 ? addColor : subColor;

		let curGold = O1HD.getServices().userSrv.getCoins();
		if (ret > 0) {
			PromiseUtil.nextFrame().then(()=> {
				O1HD.getServices().userSrv.setCoins(ret, true, this.labelEscortResult.node, null, this.node);
			});
		} else {
			if (ret + curGold < 0) {
				ret = -curGold;
			}
			O1HD.getServices().userSrv.setCoins(ret, true);
		}
	}		

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
		this._carryData.parent.destroyNode();


		let gameData = NormalGameManager._instance.getGameData();
		if (!gameData.bFirstFinishYabiao1) {
			gameData.bFirstFinishYabiao1 = true;

			let data = {
                id: "22"
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            }
            utilsView.openEventLayer(
                null
                , data
                , UI_Z_INDEX.DIALOG
            );
		}
    }

    // update (dt) {}
}
